import client from '../client';
import type { StoreListItem } from '../../types/store';
import type { ApiResponse } from '../../types/api';

interface StoresResponse {
  stores: StoreListItem[];
  pendingInvitations: Array<{
    _id: string;
    storeId: string;
    storeSlug?: string;
    storeName?: string;
    logo?: string;
    domain?: string;
    email: string;
    role?: string;
    status: string;
  }>;
}

export const storesApi = {
  list: async (): Promise<StoresResponse> => {
    const res = await client.get<ApiResponse<StoresResponse>>('/dashboard/stores');
    return res.data.data ?? { stores: [], pendingInvitations: [] };
  },

  create: async (data: {
    name: string;
    storeId?: string;
    currency?: string;
    description?: string;
    language?: string;
    logo?: string;
  }): Promise<{ storeId: string; id: string }> => {
    const res = await client.post<ApiResponse<{ storeId: string; id: string }>>('/dashboard/stores', data);
    return res.data.data!;
  },

  /**
   * Live-check whether a store slug is taken. Returns `available: false`
   * with `reason: 'invalid'` when the slug fails the server-side format
   * check (a-z0-9-, 3–30 chars).
   */
  checkId: async (id: string): Promise<{ available: boolean; reason?: string }> => {
    const res = await client.get<ApiResponse<{ available: boolean; reason?: string }>>(
      `/dashboard/stores/check-id?id=${encodeURIComponent(id)}`,
    );
    return res.data.data!;
  },

  acceptInvitation: async (storeId: string, inviteId: string): Promise<void> => {
    await client.post<ApiResponse>(`/dashboard/${storeId}/users/invitations/${inviteId}/accept`);
  },

  declineInvitation: async (storeId: string, inviteId: string): Promise<void> => {
    await client.post<ApiResponse>(`/dashboard/${storeId}/users/invitations/${inviteId}/decline`);
  },
};
